import hostname from './config.host'
import { fetchWrapper } from './fetch-wrapper'
const apiUrl: string = `${hostname}/aladdin_api/v1`

function getAllBusinessInsightsList(oauthTokenHeader: string, _selectedSharedUid: string) {
  return fetchWrapper.get(`${apiUrl}/utilities/tasks/?type=Business Insight`,oauthTokenHeader);
};

function getTaskDetails(oauthTokenHeader: string, taskSharedUid: string) {
  return fetchWrapper.get(`${apiUrl}/utilities/tasks/${taskSharedUid}/`, oauthTokenHeader);
};

function getKeywordsPerformance(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,adgroupId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&adgroup_id=${adgroupId}`,oauthTokenHeader);
}
function getKeywordsPerformanceCampaign(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,campaignId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&campaign_id=${campaignId}`,oauthTokenHeader);
}

function getNewSearchTerms(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,adgroupId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&adgroup_id=${adgroupId}`,oauthTokenHeader);
}

function getNewSearchTermsCampaign(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,campaignId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&campaign_id=${campaignId}`,oauthTokenHeader);
}

function getImpressionShare1(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,adgroupId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&adgroup_id=${adgroupId}`,oauthTokenHeader);
}

function getImpressionShare1Campaign(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,campaignId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&campaign_id=${campaignId}`,oauthTokenHeader);
}

function getImpressionShare2(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,adgroupId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&adgroup_id=${adgroupId}`,oauthTokenHeader);
}

function getImpressionShare2Campaign(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,campaignId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&campaign_id=${campaignId}`,oauthTokenHeader);
}

function getDailyAverage(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,adgroupId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&adgroup_id=${adgroupId}`,oauthTokenHeader);
}

function getDailyAverageCampaign(oauthTokenHeader: string, QUERY_ID: any, websiteSharedUid: string,campaignId: string,startDate: string,endDate: string,type: string) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${startDate}&end_date=${endDate}&type=${type}&website_shared_uid=${websiteSharedUid}&adgroup_id=${campaignId}`,oauthTokenHeader);
}

function updateInsightTaskStatus(oauthTokenHeader: any, data: any) {
  return fetchWrapper.patch(`${apiUrl}/utilities/tasks/`, data, oauthTokenHeader);
}

function postComment(oauthTokenHeader: string, data: any, object_shared_uid: any) {
  return fetchWrapper.post(`${apiUrl}/utilities/comments/${object_shared_uid}/`, data, oauthTokenHeader);
}

function getComments(oauthTokenHeader: string, object_shared_uid: any) {
  const objectSharedUids = Array.isArray(object_shared_uid)
    && object_shared_uid.map((uid:any) => `object_shared_uid=${(uid)}`).join("&");
  return fetchWrapper.get(`${apiUrl}/utilities/comments/?object_type=tasks&${objectSharedUids}`, oauthTokenHeader);
}

function putComments(oauthTokenHeader: string,data: any,object_shared_uid: any) {
  return fetchWrapper.put(`${apiUrl}/utilities/comments/${object_shared_uid}/`,data,oauthTokenHeader);
}

function getFiles(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(`${apiUrl}/utilities/file/${object_shared_uid}/`,oauthTokenHeader);
}

function uploadFile(oauthTokenHeader: string,data: any,object_shared_uid: any) {
  return fetchWrapper.post(`${apiUrl}/utilities/file/${object_shared_uid}/`,data,oauthTokenHeader);
}

function getAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(`${apiUrl}/admin/users/?active_only=True/`, oauthTokenHeader);
}

function assignBussinessInsights(oauthTokenHeader: string, data: any, taskSharedUid: string) {
  return fetchWrapper.patch(`${apiUrl}/utilities/tasks/${taskSharedUid}/`, data, oauthTokenHeader);
}

function resolveBusinessInsightsStatus(oauthTokenHeader: string, data: any, taskSharedUid: string) {
  return fetchWrapper.patch(`${apiUrl}/utilities/tasks/${taskSharedUid}/`, data, oauthTokenHeader);
}

function updateBusinessInsightsStatus(oauthTokenHeader: string, data: any, taskSharedUid: string) { 
  return fetchWrapper.patch(`${apiUrl}/utilities/tasks/${taskSharedUid}/`, data, oauthTokenHeader);
}

function createNewTask(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(`${apiUrl}/utilities/tasks/`,data,oauthTokenHeader);
}

//delete comment of business insights
function deleteComment(oauthTokenHeader: string, object_shared_uid: any, comment_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/comments/${object_shared_uid}/?comment=${comment_shared_uid}`, oauthTokenHeader);
}

//delete file of business insights
function deleteFile(oauthTokenHeader: string, file_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/file/${file_shared_uid}/`, oauthTokenHeader);
}


export const businessInsightsService = {
  getAllBusinessInsightsList,
  getTaskDetails,
  getKeywordsPerformance,
  getKeywordsPerformanceCampaign,
  getNewSearchTerms,
  getNewSearchTermsCampaign,
  getImpressionShare1,
  getImpressionShare1Campaign,
  getImpressionShare2,
  getImpressionShare2Campaign,
  getDailyAverage,
  getDailyAverageCampaign,
  updateInsightTaskStatus,
  postComment,
  getComments,
  putComments,
  getFiles,
  uploadFile,
  getAllUsers,
  assignBussinessInsights,
  resolveBusinessInsightsStatus,
  updateBusinessInsightsStatus,
  createNewTask,
  deleteComment,
  deleteFile
}
